<template>

    <div>
        
        <Button
            :size="15"
            color="#dc3545"
            colorText="#ffffff"
            tooltip="Eiminación de múltiples planificaciones"
            icon="fas fa-times"
            round
            :width="30"
            class="mr-2"
            @click.native="openModal('modal')"
            traslate
            :inactive="data.length ? false : true"
        />

        <ui-modal ref="modal" size="large" title="Eliminar puerto de destino" @close="ActionSetZindexModal(false)">

            <table class="table table-striped">
                <thead>
                    <th class="text-center">Año</th>
                    <th class="text-center">Empresa</th>
                    <th class="text-center">Total Anual</th>
                    <th class="text-center">Fecha Creación</th>
                </thead>
                <tbody>
                    <tr v-for="(item, index_item) in data" :key="index_item">
                        <!-- <td class="text-center" v-for=" (fila, index) in item.data.data" :key="index" v-text="fila"></td> -->
                        <td class="text-center" v-text="item.data.data[0]"></td>
                        <td class="text-center" v-text="item.data.data[1]"></td>
                        <td class="text-center" v-text="item.data.data[5]"></td>
                        <td class="text-center" v-text="item.data.data[6]"></td>
                    </tr>
                </tbody>
            </table>

            <div class="d-flex justify-content-between">
                <Button
                    :size="25"
                    color="#898476"
                    colorText="#ffffff"
                    tooltip="Modificar planificación"
                    text="Cancelar"
                    :width="130"
                    :height="35"
                    class="mr-2"
                    @click.native="closeModal('modal')"
                />

                <Button
                    v-if="isSend"
                    :size="25"
                    color="#dc3545"
                    colorText="#ffffff"
                    tooltip="Eliminar puerto"
                    text="Eliminar"
                    :width="130"
                    :height="35"
                    class="mr-2"
                    inactive
                />

                <Button
                    v-else
                    :size="25"
                    color="#dc3545"
                    colorText="#ffffff"
                    tooltip="Eliminar puerto"
                    text="Eliminar"
                    :width="130"
                    :height="35"
                    class="mr-2"
                    @click.native="eliminar"
                />
            </div>

        </ui-modal>

    </div>
  
</template>

<script>

    // Vue
    import Vue from "vue";

    // Toast
    import VueToastify from "vue-toastify";
    Vue.use(VueToastify);
    
    import { mapActions, mapState } from 'vuex'

    // Keen UI
    import UiModal from "keen-ui/src/UiModal";

    import Button from '../../../common/Button.vue'

    // API
    import { eliminarPuertosPrincipales } from '../../../../constants/lineas';

    export default {
        props : ['data'],
        components: { Button, UiModal },
        data() {
            return {
                isSend : false
            };
        },
        computed : {
            ...mapState('lineas',['habilitarEdicionMultipleAnual','puertosSeleccionadosPlanAnual','checkPlanificacionAnual']),
        },
        methods : {

            ...mapActions(['ActionSetZindexModal']),
            ...mapActions('lineas',['actionSetDataPlanificacionAnualTabla']),

            openModal(ref) {
                this.$refs[ref].open();
                this.ActionSetZindexModal(true);
            },

            closeModal(ref) {
                this.$refs[ref].close();
            },

            async eliminar(){

                let data  = [];
                this.isSend = true;

                this.$vToastify.loader('Eliminando planificaciones');

                this.data.map( item => data.push({ "plan_id" : item.data.data_complementaria.annual_plan_id}));

                const sql = await eliminarPuertosPrincipales({ "plans" : data });
                
                if (sql.code == 200) {
                    this.closeModal('modal');
                    this.actionSetDataPlanificacionAnualTabla();
                    this.$vToastify.stopLoader();
                    this.$vToastify.success( sql.message, "Proceso finalizado");
                    this.isSend = false;
                } else {
                    this.$vToastify.stopLoader();
                    this.$vToastify.error( sql.message, "Proceso finalizado");
                    this.isSend = false;

                }

            },
        },

    
    }
</script>
